// const URL = "http://47.95.37.182:9090";
const URL = "https://www.jansuan.com:9090";
// const URL = "https://47.95.37.182:9080";
// const URL = 'http://www.joyonb.top:9090';
export default URL;
